import ApiClient from '../../API/api';

const GET_CART_ENDPOINT = 'cart';
const PUT_PRODUCT_EQUIVALENCE_CHARGE_ENDPOINT = 'cart/product/:productId/recargo';
const DELETE_PRODUCT_ENDPOINT = 'cart/product/:productId';
const PUT_PRODUCT_QUANTITY_ENDPOINT = 'cart/product/:productId/quantity';

export class CartRepository {
  static get() {
    return ApiClient.performRequest(GET_CART_ENDPOINT);
  };

  static setEquivalenceCharge(productId, equivalenceCharge) {
    return ApiClient.performRequest(PUT_PRODUCT_EQUIVALENCE_CHARGE_ENDPOINT,
      {
        method: 'PUT',
        pathParams: { productId: productId },
        queryParams: { recargo: equivalenceCharge }
      }
    );
  };

  static async removeProduct(productId) {
    return ApiClient.performRequest(
      DELETE_PRODUCT_ENDPOINT,
      { method: 'DELETE', pathParams: { productId: productId } }
    );
  };

  static async updateProductQuantity(productId, quantity) {
    return ApiClient.performRequest(
      PUT_PRODUCT_QUANTITY_ENDPOINT,
      {
        method: 'PUT',
        pathParams: { productId: productId },
        queryParams: { quantity: quantity }
      }
    );
  };
}
